import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { Button } from 'primereact/button';

import Colors from "../utils/colors";
import { FaArrowRight, FaArrowRightLong } from "react-icons/fa6";
import HeaderProductList from "./heads/prod-l";
import HeaderSolutionsList from "./heads/solution-l";
import HeaderUseCaseList from "./heads/uses-l";

function Header(){
let navigate = useNavigate();


return (
    <header className="header" style={{zIndex:10}}>
      <div className="logo" style={{marginTop:"-8px"}}>
        <Link to="/">
          <img src="/img/logo-black.png" style={{height:"30px"}} />
        </Link>
      </div>
      <nav className="hide-on-mobile">
        <ul>
          <li>
            <div className="dropdown hangle">
              <div className="flex-row ht">
                <div>Products</div> <i className="pi pi-angle-right h-angle" style={{color:Colors.black1}}></i>
              </div>
              <HeaderProductList />
            </div>
          </li>
          <li>
            <div className="dropdown hangle">
              <div className="flex-row ht">
                <div>Solutions</div> <i className="pi pi-angle-right h-angle" style={{color:Colors.black1}}></i>
              </div>
              <HeaderSolutionsList />
            </div>
          </li>
          <li>
            <div className="dropdown hangle">
              <div className="flex-row ht">
                <div >Use Cases</div> <i className="pi pi-angle-right h-angle" style={{color:Colors.black1}}></i>
              </div>
              <HeaderUseCaseList />
            </div>
          </li>
        </ul>
      </nav>
      <nav>
        <ul style={{padding:"1em 0em"}}>
          <li className="hide-on-mobile">
            <Link to="https://business.monytrack.com/" target="_blank">
                <Button label={ "Login" } 
                    style={{backgroundColor:Colors.light, color:Colors.black, fontWeight:'normal',  fontSize:"14px", borderRadius:"5px", borderColor:Colors.gray2, padding:".7rem 1.5rem"}}
                      className="w-8rem" ></Button>
            </Link>
            </li>
          <li>
            <a target="_blank" href="https://business.monytrack.com/auth/register">
                <Button label={ "Try it for free" } autoFocus
                    style={{width:"fit-content", backgroundColor:Colors.primary, color:Colors.light, fontWeight:'normal',  fontSize:"14px", borderRadius:"5px", borderColor:Colors.primary, padding:".7rem 1.5rem", marginLeft:"0px"}}
                        className="w-8rem" ></Button>
            </a>
          </li>
        </ul>
      </nav>
    </header>
  );
};

export default Header;
